import { notification } from 'antd';

export const openNotification = (des:string) => {
    notification.open({
        message: 'LANDAO',
        description: des,
        placement: 'topRight', // Specify the position here
    });
};